<template>
  <div>
    <div class="game-header">
      <div class="backarrowDiv" v-on:click="prevChapter">
        <inline-svg
          class="arrow-svg-game"
          :src="arrowIconPath.arrowIconPrevious"
        ></inline-svg>
      </div>
      <div class="game-titles" v-if="trigger">
        <h2 v-if="currentData">
          {{ currentData.courseName }}
        </h2>
        <h6 v-if="currentData">
          {{ currentData ? currentData.name : $t("game-new.game-header.game") }}
        </h6>
        <h6 v-if="title">
          {{ title }}
        </h6>
      </div>
    </div>
    <div class="eng-progress-container">
      <div id="eng-progress-bar" class="eng-progress-bar"></div>
    </div>
  </div>
</template>

<script>
import "./game-header.scss";
import { getArrowIconPath } from "../../utils/svgConfig";
import { languageDirectionMapping } from "../../main";

export default {
  name: "GameHeader",
  props: ["currentData", "word", "trigger", "title", "progress", "total"],
  data() {
    return {
      lessonName: this.$t("game-new.game-header.game"),
      arrowIconPath: {
        arrowIconNext: "",
        arrowIconPrevious: ""
      }
    };
  },
  async created() {
    this.arrowIconPath = getArrowIconPath(localStorage.getItem("srcDirection"));
  },
  computed: {
    wordRank() {
      try {
        this.word.qWord.know = this.word.qWord.know ? this.word.qWord.know : 0;
        //console.log(trigger);
        //console.log("wordRank", this.word.qWord);
        //this.word.aaa = "cba";
        //this.wordRank = this.word.qWord.know;
        return this.word.qWord.know;
      } catch (error) {
        console.log("ERROR", error);
        return 0;
      }
    }
  },
  watch: {
    currentData() {
      console.log("I AM HERE");
      this.lessonName = this.currentData.name;
    },
    wordRank() {
      console.log("wordRank chnaged");
    },
    word() {
      this.$forceUpdate();
      console.log("word changed");
    },
    progress() {
      let precent = this.progress / this.articleNum * 100
      console.log(precent);
      document.getElementById('eng-progress-bar').style.width = precent + '%'
    },
  },
  updated() {
    console.log("UPDATED");
  },
  methods: {
    prevChapter: function(event) {
      this.$router.push({
        path: `/chapter/`
      });
    }
  },
  components: {}
};
</script>

<style scoped>
.game-header {
  padding: 6px;
  height: 60px;
}

.backarrowDiv {
  display: flex;
  width: 50px;
  height: 50px;
}
.arrow-svg-game {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// game-header.vue?43a6fbb2